<template>
    <div class="relatedArticles">
        <h2 class="baron headerText">Related news</h2>
        <div class="grid">
            <template v-for="article in articles">
                <ItemArticle :article="article" />
            </template>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps<{ id: number }>()
const { data: articles } = useLazyAsyncData(`related-${props.id}`, () => $fetch(`https://cms.eic-federation.eu/search/similar/${props.id}`), { transform: (d: any) => d?.hits || [] })
</script>

<style lang="scss" scoped>
.relatedArticles {
    margin: 0 var(--size-margin-page);

    display: flex;
    flex-direction: column;
    gap: var(--size-gutter-double);

    h2 {
        border-top: var(--size-thickness) solid var(--color-primary);
        font-weight: normal;
        color: var(--color-primary);
        padding-top: var(--size-margin-page);
    }

    .grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        gap: var(--size-margin-page);
    }
}

@media screen and (max-width: 1280px) {
    .relatedArticles {
        .grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }
    }
}

@media screen and (max-width: 1024px) {
    .relatedArticles {
        .grid {
            grid-template-columns: repeat(2, minmax(0, 1fr));
        }
    }
}

@media screen and (max-width: 600px) {
    .relatedArticles {
        width: 100%;
        overflow: hidden;

        margin-bottom: calc(0px - var(--size-gutter-sections));
        margin-left: 0;

        h2 {
            margin: 0 var(--size-margin-page);
        }

        .grid {
            display: flex;
            flex-direction: row;
            gap: 0;

            overflow-x: auto;
            overflow-y: hidden;
            scroll-snap-type: x mandatory;
            scrollbar-width: none;
            -ms-overflow-style: none;

            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;

            &::-webkit-scrollbar {
                display: none;
            }

            padding-bottom: var(--size-gutter-sections);
            padding-right: 48px;

            &:deep(.itemArticle) {
                scroll-snap-align: start;
                scroll-snap-align: start;
                width: calc(100vw - 48px);
                flex-shrink: 0;
                border-left: var(--size-margin-page) solid white;
            }
        }
    }
}
</style>